import TeacherSubscribeManage from './src/main';

/* istanbul ignore next */
TeacherSubscribeManage.install = function(Vue) {
  Vue.component(TeacherSubscribeManage.name, TeacherSubscribeManage);
};

export default TeacherSubscribeManage;
